import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Laverage(props) {
  return (
    <div className="laverage_section p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>TekRevol’s Proficient Mobile App Development Cycle</h2>
            <p>
              TekRevol holds a strong base for developing full-fledged mobile
              applications supported by high-tech tools and masterful app
              developers in Saudi Arabia. As a top-grade{" "}
              <Link to="/sa/mobile-apps-development-in-saudi-arabia">
                mobile app development company
              </Link>
              , we further improve our process by regulating a user-centric
              approach that allows us to offer a pleasant experience to the
              audience using our app. Meanwhile, there is complete transparency
              throughout the whole development cycle keeping our clients updated
              at each step.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={11} className="m-auto">
            <div className="process_listing">
              <div className="process_item">
                <div className="number">01</div>
                <h4 className="saudia_h4_head">Ideation</h4>
                <p>Conducting Product Discovery and Product Research.</p>
              </div>
              <div className="process_item">
                <div className="number">02</div>
                <h4 className="saudia_h4_head">Design</h4>
                <p>Creating the UX Design, UI Design, and Branding</p>
              </div>
              <div className="process_item">
                <div className="number">03</div>
                <h4 className="saudia_h4_head">Development</h4>
                <p>Coding the app courtesy of our veteran engineers</p>
              </div>
              <div className="process_item">
                <div className="number">04</div>
                <h4 className="saudia_h4_head">Quality Assurance</h4>
                <p>
                  Testing the app and making sure that everything works well
                </p>
              </div>
              <div className="process_item">
                <div className="number">05</div>
                <h4 className="saudia_h4_head">Maintenance & Support</h4>
                <p>Co-managing the app with your technology team.</p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Laverage;
